import type { GeometryPadWidgetConfig } from '../geometrypad.model';

export const SINGLE_CIRCLE_PRESET: GeometryPadWidgetConfig = {
  id: 'single-circle',
  type: 'geometrypad',
  params: {
    elements: {
      c1: {
        type: 'Circle',
        params: { center: { x: 0, y: 0 }, r: 4 },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
  },
};
